import { giphyRed } from '@giphy/colors'
import styled from 'styled-components'
import TimeInput from '../time-input'

const Container = styled.div`
    align-items: center;
    display: flex;
    margin-top: 12px;
    width: 100%;
`

const Duration = styled.div<{ invalid: boolean }>`
    background: ${({ invalid }) => (invalid ? giphyRed : '#fff')};
    border-radius: 16px;
    box-shadow: 0 11px 30px rgba(0, 0, 0, 0.5);
    color: #000;
    font-size: 15px;
    font-weight: bold;
    height: 32px;
    line-height: 32px;
    margin: 0 auto;
    text-align: center;
    user-select: none;
    width: 80px;
`

type Props = {
    duration: number
    startTime: number
    endTime: number
    isInvalid?: boolean
    onUpdate: (start: number, end: number) => void
}

const CreationToolsTrimmerInputs = ({ duration, startTime, endTime, isInvalid = false, onUpdate }: Props) => (
    <Container>
        <TimeInput
            {...{
                value: startTime,
                min: 0,
                max: endTime - 0.1, // adding a buffer from the end to prevent the duration from being 0
                onUpdate: (seconds) => onUpdate(seconds, endTime),
            }}
        />
        <Duration invalid={isInvalid}>{Math.round(endTime - startTime)}s</Duration>
        <TimeInput
            {...{
                value: endTime,
                min: startTime + 0.1, // adding a buffer from the end to prevent the duration from being 0
                max: duration,
                onUpdate: (seconds) => onUpdate(startTime, seconds),
            }}
        />
    </Container>
)

export default CreationToolsTrimmerInputs
